// extracted by mini-css-extract-plugin
module.exports = {"expert-panel__image":"ExpertPanel_expert-panel__image___GnrA","expert-panel":"ExpertPanel_expert-panel__SfT_N"};